var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoMain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 66 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xEC\x82\x90\xEC\x82\x90\xEB\xA1\x9C\xEA\xB3\xA0",
    clipPath: "url(#clip0_130_343)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.07 12.3893L13.5232 4.2717C14.8137 0.423515 19.2459 -0.756752 22.356 1.95867C23.954 3.35402 26.2202 5.58908 27.6193 7.17442C29.2426 9.01338 29.7879 11.4662 28.9233 13.7918C28.3807 15.2499 26.9618 16.595 25.854 17.6812C25.419 18.1078 24.88 18.5057 24.464 18.969L21.3648 15.965L15.6828 21.6092L19.8817 25.8337L45.632 0.314178C46.0426 0.00320422 46.4812 -0.100752 46.9686 0.112538L64.6748 17.5728C67.2187 20.5544 65.9345 24.96 62.2376 26.151L54.0388 27.618C53.961 27.6673 53.8742 28.0796 53.8489 28.1996C53.3605 30.5396 53.1453 33.0471 52.5937 35.3574C51.5618 39.6797 46.2605 40.9845 43.3042 37.7L34.0519 28.4694L41.5715 21.0042L44.6707 24.0082L50.3662 18.3775L46.1249 14.239L20.5183 39.5596C19.5453 40.4737 18.791 39.7935 18.0404 39.0712C12.3892 33.6287 7.01467 27.8645 1.33267 22.4417C-1.29717 19.3813 0.160634 14.8591 4.005 13.8133L12.07 12.3884L12.07 12.3893Z",
    fill: "var(--fill-0, #EEE0AF)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_130_343"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMain);
export default __webpack_public_path__ + "static/media/logo-main.610d332c18423e29fa2589940f42f9c1.svg";
export { ForwardRef as ReactComponent };